import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg, datumNL } from '../components/PortalLayout';

const A = '#00D4AA';

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);
  const [rollen, setRollen] = useState([]);
  const [eigenId, setEigenId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [naam, setNaam] = useState('');
  const [email, setEmail] = useState('');
  const [rolId, setRolId] = useState('');
  const [bezig, setBezig] = useState(false);
  const [melding, setMelding] = useState(null);

  const laad = async () => {
    setLoading(true); setError(null);
    try {
      const [a, r] = await Promise.all([
        api.get('/klantportaal/accounts'),
        api.get('/klantportaal/accounts/rollen'),
      ]);
      setAccounts(a.data.accounts || []);
      setEigenId(a.data.eigen_account_id || null);
      setRollen(r.data.rollen || []);
      if (!rolId && r.data.rollen && r.data.rollen.length) {
        const melder = r.data.rollen.find((x) => x.naam === 'Melder');
        setRolId(String((melder || r.data.rollen[0]).id));
      }
    } catch (e) { setError('Kon accounts niet laden'); }
    setLoading(false);
  };

  useEffect(() => { laad(); }, []);

  const uitnodigen = async () => {
    if (!naam.trim() || !email.trim() || !rolId) { setMelding({ type: 'err', tekst: 'Vul naam, e-mail en rol in.' }); return; }
    setBezig(true); setMelding(null);
    try {
      const r = await api.post('/klantportaal/accounts/uitnodigen', { naam: naam.trim(), email: email.trim(), portal_rol_id: Number(rolId) });
      if (r.data && r.data.success) {
        setMelding({ type: 'ok', tekst: r.data.mail_verzonden === false ? 'Account aangemaakt (mail kon niet verstuurd worden).' : ('Uitnodiging verstuurd naar ' + email.trim()) });
        setNaam(''); setEmail(''); laad();
      } else { setMelding({ type: 'err', tekst: (r.data && r.data.message) || 'Uitnodigen mislukt' }); }
    } catch (e) {
      const m = e.response && e.response.data && e.response.data.message;
      setMelding({ type: 'err', tekst: m || 'Uitnodigen mislukt' });
    }
    setBezig(false);
  };

  const toggleActief = async (a) => {
    try {
      const r = await api.put('/klantportaal/accounts/' + a.id + '/actief');
      if (r.data && r.data.success) laad();
      else setMelding({ type: 'err', tekst: (r.data && r.data.message) || 'Wijzigen mislukt' });
    } catch (e) { setMelding({ type: 'err', tekst: (e.response && e.response.data && e.response.data.message) || 'Wijzigen mislukt' }); }
  };

  const verwijder = async (a) => {
    if (!window.confirm('Account van ' + a.naam + ' definitief verwijderen?')) return;
    try {
      const r = await api.delete('/klantportaal/accounts/' + a.id);
      if (r.data && r.data.success) laad();
      else setMelding({ type: 'err', tekst: (r.data && r.data.message) || 'Verwijderen mislukt' });
    } catch (e) { setMelding({ type: 'err', tekst: (e.response && e.response.data && e.response.data.message) || 'Verwijderen mislukt' }); }
  };

  const inp = { width: '100%', boxSizing: 'border-box', padding: '11px 14px', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: 14, marginBottom: 10, outline: 'none', background: '#fff', color: '#1e293b' };
  const knop = { padding: '6px 12px', borderRadius: 8, fontSize: 13, cursor: 'pointer', background: '#fff' };

  return (
    <PortalLayout titel="Collega's beheren">
      <StateMsg loading={loading} error={error} />
      {!loading && !error && (
        <>
          <div style={{ ...card }}>
            <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 15, marginBottom: 10 }}>Collega uitnodigen</div>
            <input style={inp} placeholder="Naam" value={naam} onChange={(e) => setNaam(e.target.value)} />
            <input style={inp} type="email" placeholder="E-mailadres" value={email} onChange={(e) => setEmail(e.target.value)} />
            <select style={inp} value={rolId} onChange={(e) => setRolId(e.target.value)}>
              {rollen.map((r) => <option key={r.id} value={r.id}>{r.naam}</option>)}
            </select>
            <button onClick={uitnodigen} disabled={bezig} style={{ width: '100%', padding: '12px', border: 'none', borderRadius: 10, background: A, color: '#06281f', fontSize: 15, fontWeight: 700, cursor: bezig ? 'not-allowed' : 'pointer', opacity: bezig ? 0.6 : 1 }}>{bezig ? 'Bezig\u2026' : 'Uitnodiging versturen'}</button>
            {melding && <div style={{ marginTop: 10, fontSize: 13, color: melding.type === 'ok' ? '#166534' : '#dc2626' }}>{melding.tekst}</div>}
          </div>
          <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 14, margin: '16px 0 8px' }}>Accounts ({accounts.length})</div>
          {accounts.length === 0 && <p style={{ color: '#64748b', fontSize: 13 }}>Nog geen accounts.</p>}
          {accounts.map((a) => (
            <div key={a.id} style={{ ...card, opacity: a.actief === false ? 0.6 : 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{a.naam}{a.id === eigenId ? ' (jij)' : ''}</div>
                  <div style={{ color: '#64748b', fontSize: 13 }}>{a.email}</div>
                </div>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#0369a1', background: '#e0f2fe', padding: '3px 10px', borderRadius: 999 }}>{a.rol_naam || '\u2014'}</span>
              </div>
              <div style={{ marginTop: 6, fontSize: 12, color: '#94a3b8' }}>
                {a.heeft_wachtwoord ? ('Laatst ingelogd: ' + (a.laatst_ingelogd ? datumNL(a.laatst_ingelogd) : 'nog niet')) : 'Uitnodiging open \u2014 wachtwoord nog niet ingesteld'}
                {a.actief === false ? ' \u00b7 gedeactiveerd' : ''}
              </div>
              {a.id !== eigenId && (
                <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                  <button onClick={() => toggleActief(a)} style={{ ...knop, border: '1px solid #cbd5e1', color: '#475569' }}>{a.actief === false ? 'Activeren' : 'Deactiveren'}</button>
                  <button onClick={() => verwijder(a)} style={{ ...knop, border: '1px solid #fecaca', color: '#dc2626' }}>Verwijderen</button>
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </PortalLayout>
  );
}
